import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ChessGame from '@/modules/chess-game';
import Homepage from '@/modules/home';

const elements = [
  {
    Component: Homepage,
    path: '/'
  },
  {
    Component: ChessGame,
    path: '/chess'
  }
];

export const RouterProvider = () => {
  return (
    <BrowserRouter>
      <Routes>
        {elements.map(({ Component, path }, idx) => (
          <Route
            key={idx}
            element={
              <React.Suspense fallback={null}>
                <Component />
              </React.Suspense>
            }
            path={path}
          />
        ))}
      </Routes>
    </BrowserRouter>
  );
};
